
export const fetchDelegationRules = () => ({
    method: 'GET',
    url: '/delegation-rules'
});
export const fetchDelegationRulesUnpopulated = () => ({
    method: 'GET',
    url: '/delegation-rules/unpopulated'
});
export const createDelegationRule = (data) => ({
    method: 'POST',
    url: '/delegation-rules',
    data
})
export const deleteDelegationRule = (_id) => ({
    method: 'DELETE',
    url: `/delegation-rules/${_id}`,
})
export const updateDelegationRule = (delegationId, data) => ({
    method: 'PUT',
    url: `/delegation-rules/${delegationId}`,
    data
})